import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IChangePaymentSystemPayload } from '../types';
import {
  AFFILIATE_CHANGE_PAYMENT_SYSTEM_MUTATION_KEY,
  AFFILIATE_CREATE_PAYMENT_SYSTEM_API_URL,
  AFFILIATE_PAYMENT_SYSTEM_DETAILS_INFO_QUERY_KEY,
  AFFILIATE_RESEND_PAYMENT_SYSTEM_API_URL,
  PAYMENT_SYSTEM_DETAILS_PERMISSIONS,
} from '../constants';

export default function useChangePaymentSystemMutation(): IContextMutationResult<void, Error, IChangePaymentSystemPayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IChangePaymentSystemPayload>({
    mutationKey: [AFFILIATE_CHANGE_PAYMENT_SYSTEM_MUTATION_KEY],
    mutationFn: ({ id = '', ...payload }) => fetchPost<void>(
      id ? AFFILIATE_RESEND_PAYMENT_SYSTEM_API_URL : AFFILIATE_CREATE_PAYMENT_SYSTEM_API_URL,
      payload,
      {
        permission: id ? PAYMENT_SYSTEM_DETAILS_PERMISSIONS.UPDATE : PAYMENT_SYSTEM_DETAILS_PERMISSIONS.CREATE,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient, variables }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATE_PAYMENT_SYSTEM_DETAILS_INFO_QUERY_KEY] });
      displayPresetToast(variables.id ? 'edited' : 'created');
    },
  });
}
